module.exports = __webpack_public_path__ + "img/icon-cta-arrow-black.96b948c8.svg";